// About.jsx
import React, { useEffect, useState } from "react";
import "./About.css";
import AOS from "aos";
import "aos/dist/aos.css";

import aboutImg from "../components/images/about1.svg";
import letterImg from "../components/images/certificate.webp";
import { FaBolt, FaBullseye, FaShieldAlt } from "react-icons/fa";
import certificateInfo from "../components/images/certificate-info.jpg";

const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
      offset: 0,
    });
    AOS.refresh();

  }, []);
  const [showForm, setShowForm] = useState(false);


  const setsApart = [
    {
      title: "Free Trial",
      desc: "Before commencement take a free trial for 7–15 days."
    },
    {
      title: "Over 2 DECADES Of R&D Experience",
      desc: "Using innovative methods and custom baits for optimal control and effectiveness."
    },
    {
      title: "Effective Response Time",
      desc: "The technician will be at your doorstep within 24 hours of complaint."
    },
    {
      title: "Pay ONLY When SATISFIED**",
      desc: "Will not send you an invoice if we are unable to give you up to 85–90% results."
    },
    {
      title: "Timely Quality Audits",
      desc: "Delivering prompt solutions to address difficult areas effectively."
    },
    {
      title: "Pesticides License, PF, ESIC, Workmen",
      desc: "Compensation Policy Fully Compliant."
    }
  ];

  const tpcAdvantage = [
    "Intelligent Solutions Tailored for Discerning Customers",
    "Ethical, law-compliant practices meeting all standards",
    "Personalized and integrated approach",
    "Comprehensive solution for all your manpower needs and requirements",
    "Efficient, cost-effective, quality-focused customer delivery model.",
    "Trained team members focusing on operational competencies",
    "Proactive management focusing on building long-term relationships",
    "Agile and smart workforce",
    "High-quality professional services"
  ];

  return (
    <div className="about-page">
      {/* HERO */}
      <section className="about-topbar py-5">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-8 col-12">
              <div className="about-topbar-content" data-aos="fade-up">
                <span className="mini-tag">About Us</span>
                <h1>Built On Trust. Driven By Better Protection.</h1>
                <p>
                  Safe, reliable, and practical pest management solutions designed for
                  healthier homes, workplaces, and long-term peace of mind.
                </p>
              </div>
            </div>


            <div className="col-lg-4 col-12">


              <img
                src={require("../components/images/experience-badge.png")}
                alt="25 Years Experience"
                className="experience-img"
                data-aos="fade-left"
              />


            </div>
          </div>
        </div>
        {/* </div> */}
      </section>

      {/* ABOUT */}
      <section className="about-section py-5">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6 col-12" data-aos="fade-right">
              <div className="about-image">
                <img src={aboutImg} alt="About TPC" className="img-fluid w-100" />
              </div>
            </div>

            <div className="col-lg-6 col-12" data-aos="fade-left">
              <div className="about-content">
                <span className="section-tag">Who We Are</span>
                <h2>Total Pest Control (TPC)</h2>
                <p>
                  Total Pest Control is a trusted pest management company delivering
                  safe, effective, and practical solutions for homes, commercial
                  spaces, and industries.
                </p>
                <p>
                  With years of hands-on expertise, trained professionals, and
                  customer-focused service, we help create healthier environments
                  through reliable pest prevention and long-term protection.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VMV */}
      <section className="vmv-diagram py-5">
        <div className="container">

          <div className="vmv-diagram-wrapper">

            {/* Left */}
            <div className="vmv-box left-box">
              <div className="vmv-image-box">
                <img
                  src={require("../components/images/vision1.png")}
                  alt="Vision"
                  className="vmv-img"
                />
              </div>

              {/* <h3>VISION</h3> */}

              <p>
                To be India’s most trusted and preferred pest management partner.
              </p>
            </div>

            {/* Center */}
            <div className="vmv-box center-box">
              <div className="vmv-image-box">
                <img
                  src={require("../components/images/mission1.png")}
                  alt="Mission"
                  className="vmv-img"
                />
              </div>

              {/* <h3>MISSION</h3> */}

              <p>
                Deliver safe, reliable and long-term pest protection solutions.
              </p>
            </div>

            {/* Right */}
            <div className="vmv-box right-box">
              <div className="vmv-image-box">
                <img
                  src={require("../components/images/value1.png")}
                  alt="Values"
                  className="vmv-img"
                />
              </div>
              {/* 
              <h3>VALUES</h3> */}

              <p>
                Integrity, safety, quality and customer-first service.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* WHAT SETS US APART */}
      <section className="sets-apart py-5">
        <div className="container">
          <div className="section-heading" data-aos="fade-up">

            <h2>— What Sets Us Apart —</h2>
          </div>

          <div className="row gx-5 gy-4">
            {setsApart.map((item, index) => (
              <div
                className="col-lg-6 col-md-6 col-12"
                key={index}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="list-card h-100">
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* TPC ADVANTAGE */}
      <section className="tpc-advantage py-5">
        <div className="container">
          <div className="section-heading" data-aos="fade-up">

            <h2>— The TPC Advantage —</h2>
          </div>
          <div className="row g-4">
            {tpcAdvantage.map((item, index) => (
              <div
                className={`col-lg-4 col-md-6 col-12 ${index === tpcAdvantage.length - 1
                  ? "mx-auto"
                  : ""
                  }`}
                key={index}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="advantage-strip h-100">
                  <p>{item}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* LETTER */}
      <section className="letter-section py-5">
        <div className="container">
          <div className="row align-items-center g-4">

            {/* Right Letter */}
            <div className="col-lg-6 col-12" data-aos="fade-left">
              <div className="letter-preview-wrap" onClick={() => setShowForm(true)}>
                <img
                  src={letterImg}
                  alt="Appreciation Letter"
                  className="img-fluid letter-preview-img"
                />
              </div>
            </div>

            {/* Left Infographic */}
            <div className="col-lg-6 col-12" data-aos="fade-right">
              <div className="letter-info-wrap">
                <img
                  src={certificateInfo}
                  alt="Certificate Infographic"
                  className="img-fluid certificate-info-img"
                />
              </div>
            </div>


          </div>
        </div>

        {/* Popup Letter */}
        {showForm && (
          <div className="letter-overlay" onClick={() => setShowForm(false)}>
            <div className="letter-popup" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={() => setShowForm(false)}>
                ×
              </button>

              <img
                src={letterImg}
                alt="Appreciation Letter Large"
                className="img-fluid popup-letter-img"
              />
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default About;




